export const DRESSING_HISTORY_REQUEST = "DRESSING_HISTORY_REQUEST";
export const DRESSING_HISTORY_SUCCESS = "DRESSING_HISTORY_SUCCESS";
export const DRESSING_HISTORY_FAILED = "DRESSING_HISTORY_FAILED";
